import React from 'react';

const BugReportIframe = () => {
  return (
    <iframe
      className="airtable-embed"
      src="https://airtable.com/embed/app8NIMPHgYuvBnaW/pag0RKaPSCaprjw88/form"
      frameBorder="0"
      width="100%"
      height="533"
      style={{ background: 'transparent', border: '1px solid #ccc' }}
    />
  );
};

export default BugReportIframe;
